import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import {
    CONTEXT_ROOT,
    IS_DEV,
    STATIC_ROOT,
    URL_PAGE_FACEBOOK,
    URL_PAGE_GOOGLEPLUS,
    URL_PAGE_TWITTER
} from '../../constants';
import { PATH } from '../../constants/path';
import { GOOGLE, APPLE } from '../../constants/mobile';
import { DEFAULT_LOCALE, LOCALES } from '../../constants/locale';

import DownloadButton from '../button/DownloadButton';
import LocalizedNavLink from '../router/LocalizedNavLink';

import './FooterComponent.scss';

const unlocalizedCurrentPath = () =>
    LOCALES.reduce((acc, cur) => acc.replace(`/${cur}/`, '/'), window.location.pathname);

class FooterComponent extends React.Component {
    renderDevLanguageLink = () => {
        if (LOCALES.length) {
            return (
                <div className="dev-div">
                    Changer de langue :
                    {/* On force un reload de l'app pour changer de langue, seule solution trouvé pour le moment pour que le changement soit effectif */}
                    {LOCALES.map((locale, i, all) => (
                        <a
                            href={`${CONTEXT_ROOT}${
                                locale === DEFAULT_LOCALE ? '' : `/${locale}`
                            }${unlocalizedCurrentPath()}`}
                            key={i}>
                            {' '}
                            {locale} {i === all.length - 1 ? '' : '|'}
                        </a>
                    ))}
                </div>
            );
        }
    };

    renderDevLink = () => {
        return <div></div>;
    };

    renderDevStuff = () => {
        if (IS_DEV) {
            return (
                <div className="conteneur conteneur-mobile">
                    <hr />
                    {this.renderDevLanguageLink()}
                    {this.renderDevLink()}
                </div>
            );
        }
    };

    renderSocialMedia = () => {
        const { i18n, BRAND_NAME } = this.props;

        if (URL_PAGE_FACEBOOK || URL_PAGE_TWITTER || URL_PAGE_GOOGLEPLUS) {
            return (
                <div className="reseaux-sociaux">
                    <p className="bold hidden-mobonly">{i18n.TITLE_SMO}</p>
                    <div>
                        {URL_PAGE_FACEBOOK && (
                            <LocalizedNavLink
                                to={URL_PAGE_FACEBOOK}
                                target="_blank"
                                title={format(i18n.FACEBOOK_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/facebook-rond.png`}
                                    alt={format(i18n.FACEBOOK_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                        {URL_PAGE_TWITTER && (
                            <LocalizedNavLink
                                to={URL_PAGE_TWITTER}
                                target="_blank"
                                title={format(i18n.TWITTER_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/twitter-rond.png`}
                                    alt={format(i18n.TWITTER_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                        {URL_PAGE_GOOGLEPLUS && (
                            <LocalizedNavLink
                                to={URL_PAGE_GOOGLEPLUS}
                                target="_blank"
                                title={format(i18n.GOOGLEPLUS_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/googleplus-rond.png`}
                                    alt={format(i18n.GOOGLEPLUS_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                    </div>
                </div>
            );
        }
    };

    renderMobileAppButtons = () => {
        const { i18n } = this.props;

        return (
            <div className="mobile-app">
                <p className="bold">{i18n.TITLE_MOBILE_APP}</p>
                <div className="button-wrapper">
                    <DownloadButton type={GOOGLE} inverted />
                    <DownloadButton type={APPLE} inverted />
                </div>
            </div>
        );
    };

    showCmp() {
        window.Didomi.preferences.show();
    }

    handleKeyDown = e => {
        if (e.key === 'Enter') {
            window.Didomi.preferences.show();
        }
    };

    render() {
        const { i18n } = this.props;
        return (
            <footer id="pied-de-page" role="contentinfo" className="pieddepage">
                <div className="conteneur conteneur-mobile">
                    <ul>
                        <li>
                            <LocalizedNavLink
                                to={PATH.HOW_IT_WORK_PATH}
                                title={i18n.LINKS.HOW_IT_WORKS.TITLE}>
                                {i18n.LINKS.HOW_IT_WORKS.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <LocalizedNavLink to={PATH.FAQ_PATH} title={i18n.LINKS.FAQ.TITLE}>
                                {i18n.LINKS.FAQ.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <LocalizedNavLink
                                to={PATH.CONTACTREQUEST_PATH}
                                title={i18n.LINKS.CUSTOMER_SERVICE.TITLE}>
                                {i18n.LINKS.CUSTOMER_SERVICE.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <LocalizedNavLink to={PATH.TERMS_PATH} title={i18n.LINKS.TERMS.TITLE}>
                                {i18n.LINKS.TERMS.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <LocalizedNavLink
                                to={PATH.LEGAL_NOTICE_PATH}
                                title={i18n.LINKS.LEGAL_NOTICE.TITLE}>
                                {i18n.LINKS.LEGAL_NOTICE.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <LocalizedNavLink
                                to={PATH.TERMS_OF_SALES}
                                title={i18n.LINKS.TERMS_OF_SALES.TITLE}>
                                {i18n.LINKS.TERMS_OF_SALES.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <LocalizedNavLink
                                to={PATH.PRIVACY_POLICY_PATH}
                                title={i18n.LINKS.PRIVACY_POLICY.TITLE}>
                                {i18n.LINKS.PRIVACY_POLICY.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <span
                                className="link"
                                tabIndex="0"
                                onKeyDown={this.handleKeyDown}
                                onClick={this.showCmp}>
                                {i18n.CONSENT_CHOICES}
                            </span>
                        </li>
                    </ul>
                    <ul></ul>
                </div>
                {this.renderDevStuff()}
            </footer>
        );
    }
}

FooterComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.FOOTER,
        BRAND_NAME: state.i18n.common.BRAND_NAME
    };
};

export default connect(mapStateToProps)(FooterComponent);



// WEBPACK FOOTER //
// ./src/components/footer/FooterComponent.js